import React, { useContext, useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { PlusCircle, Trash, ChatLeftText } from 'react-bootstrap-icons';
import { ChatContext } from '../contexts/ChatContext';

moment.locale('es');

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0
  },
  header: {
    padding: '10px',
    borderBottom: '1px solid #eee'
  },
  newChatBtn: {
    width: '100%',
    padding: '8px',
    background: '#f0f0f0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    fontSize: '13px'
  },
  list: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: '13px'
  }
};

export default function ConversationList({ onAfterSelect, onAfterNew }) {
  const { conversaciones, activeConv, cargarConversaciones, seleccionarConversacion, nuevaConversacion, eliminarConversacion } = useContext(ChatContext);

  useEffect(() => {
    cargarConversaciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ordenadas = [...conversaciones].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button
          type="button"
          style={styles.newChatBtn}
          onClick={() => {
            nuevaConversacion();
            onAfterNew && onAfterNew();
          }}
        >
          <PlusCircle size={14} /> Nuevo chat
        </button>
      </div>

      <div style={styles.list}>
        {ordenadas.length === 0 && (
          <p style={{ textAlign: 'center', color: '#888', fontSize: '13px', padding: '20px' }}>Sin conversaciones aún.</p>
        )}
        {ordenadas.map((c) => (
          <div
            key={c._id}
            style={{
              ...styles.item,
              borderLeft: activeConv?._id === c._id ? '3px solid #007bff' : '3px solid transparent',
              background: activeConv?._id === c._id ? '#e7f1ff' : 'transparent'
            }}
            onClick={() => {
              seleccionarConversacion(c._id);
              onAfterSelect && onAfterSelect();
            }}
          >
            <ChatLeftText size={14} color="#888" style={{ flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.titulo}</div>
              <div style={{ color: '#aaa', fontSize: '11px' }}>{moment(c.updatedAt).fromNow()}</div>
            </div>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                eliminarConversacion(c._id);
              }}
              title="Eliminar"
              style={{ background: 'transparent', border: 'none', color: '#dc3545', cursor: 'pointer', flexShrink: 0 }}
            >
              <Trash size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
